<template>
    <div class="form-container">
        <h2>{{ isEditing ? 'Edit' : 'Add' }} Employee</h2>
        <hr>

        <div v-if="errorMessage" class="error-message">
            <p>{{ errorMessage }}</p>
        </div>
        <form @submit.prevent="submitForm">
            <label>Full Name <span class="required">*</span></label>
            <input type="text" v-model="employee.name" placeholder="Full Name" required>
            <div v-if="errors.name" class="error-message">{{ errors.name[0] }}</div>

            <label>Email <span class="required">*</span></label>
            <input type="email" v-model="employee.email" placeholder="Email" required>
            <div v-if="errors.email" class="error-message">{{ errors.email[0] }}</div>

            <label>Department</label>
            <input type="text" v-model="employee.department" placeholder="Department">
            <div v-if="errors.department" class="error-message">{{ errors.department[0] }}</div>

            <label>Password <span class="required" v-if="!isEditing">*</span></label>
            <input type="password" v-model="employee.password" placeholder="Password">
            <div v-if="errors.password" class="error-message">{{ errors.password[0] }}</div>

            <div class="btn-group">
                <button type="submit" class="btn btn-sm">{{ isEditing ? 'Update' : 'Add' }}</button>
                <button type="button" class="btn btn-sm cancel-btn"
                    @click="$router.push('/dashboard/employees')">Cancel</button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            employee: { name: '', email: '', department: '', password: '' },
            isEditing: false,
            errorMessage: null,
            errors: {}
        };
    },
    methods: {
        async submitForm() {
            this.errorMessage = null;
            this.errors = {};
            try {
                if (this.isEditing) {
                    await this.$api.put(`/employees/${this.$route.params.id}`, this.employee);
                } else {
                    await this.$api.post('/employees', this.employee);
                }
                this.$router.push('/dashboard/employees');
            } catch (error) {
                if (error.response?.status === 422) {
                    this.errors = error.response.data.errors;
                } else {
                    this.errorMessage = 'An error occurred while saving the employee. Please try again later.';
                }
            }
        },
        async fetchEmployee() {
            if (this.$route.params.id) {
                this.isEditing = true;
                try {
                    const response = await this.$api.get(`/employees/${this.$route.params.id}`);
                    this.employee = { ...response.data.user, department: response.data.department };
                } catch (error) {
                    this.errorMessage = 'Error fetching employee data.';
                }
            }
        }
    },
    mounted() {
        this.fetchEmployee();
    }
};
</script>

<style scoped>
.form-container {
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
